import { Typography } from '@mui/material';
import { FieldErrors, useFormContext } from 'react-hook-form';

import { Select } from '@/components/Form/Select';

import { useTranslate } from '@/hooks/useTranslate';

import { getUnemployedProfessions } from '@/utils/employment';

import { UpdatePersonalInfo } from '../types';

type UnemployedFormSectionProps = {
  visibleErrors: FieldErrors<UpdatePersonalInfo>;
};

export function UnemployedFormSection({
  visibleErrors,
}: Readonly<UnemployedFormSectionProps>) {
  const { t } = useTranslate();
  const { control } = useFormContext();

  return (
    <>
      <Typography variant="caption">
        {t(
          'updatePersonalInfo.employmentInfoForm.field.unemploymentType.label',
        )}
      </Typography>
      <Select
        options={getUnemployedProfessions().options.map(item => ({
          value: item.value,
          text: t(item.text ?? ''),
        }))}
        control={control}
        name="employmentDetailed.employmentDesc"
        error={!!visibleErrors.employmentDetailed?.employmentDesc}
        helperText={visibleErrors.employmentDetailed?.employmentDesc?.message}
        fullWidth
        placeholder={t(
          'updatePersonalInfo.employmentInfoForm.field.unemploymentType.placeholder',
        )}
        rules={{
          required: t(
            'updatePersonalInfo.employmentInfoForm.field.unemploymentType.error.required',
          ),
        }}
        useDrawerOnMobile
        withSearchBar
      />
    </>
  );
}
